module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"Average Occupancy Percentage":"Average Occupancy Rate","Max Occupancy":"Max Occupancy","Min Occupancy":"Min Occupancy","Average Occupancy":"Average Occupancy"}}')
  delete Component.options._Ctor
}
